import React, { useEffect } from "react";
import Modal from "@mui/material/Modal";
import { Button } from "@mui/material";

import "./WSGREntryModal.scss";

const WSGREntryModal = ({ open, onClose, onConfirm }) => {
  useEffect(() => {
    const handleEscKey = (event) => {
      if (
        (event.keyCode === 27 ||
          event.which === 27 ||
          event.key === "Escape") &&
        open
      ) {
        // Don't allow ESC to close this modal - only button click
        event.preventDefault();
        event.stopPropagation();
      }
    };

    if (open) {
      document.addEventListener("keydown", handleEscKey, true);
    }

    return () => {
      document.removeEventListener("keydown", handleEscKey, true);
    };
  }, [open]);

  const handleBackdropClick = (event) => {
    // Prevent closing on backdrop click
    event.stopPropagation();
  };

  return (
    <Modal open={open} onClose={handleBackdropClick}>
      <div className="ws-gr-entry-modal">
        <div className="ws-gr-entry-modal-content">
          <div className="ws-gr-entry-modal-title">Portfolio Model Notice</div>
          <div className="ws-gr-entry-modal-body">
            The rebalance calculator uses a model portfolio amount for all
            calculations. Results are for demonstration only and do not reflect
            actual investments.
          </div>
          <div className="ws-gr-entry-modal-actions">
            <Button className="ws-gr-entry-modal-button" onClick={onConfirm}>
              Yes, I understand
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default WSGREntryModal;
